import axios from 'axios';
import backendAxios from '../utils/backendAxios';

import { GET_CATEGORIES, GET_CATEGORY, GET_SUBCATEGORY, ERROR_CATEGORIES } from './types';
import { URL } from './url';

// get all categories status true (2025)
export const getCategories = () => async dispatch => {
  try {
    const res = await backendAxios.get(`/api/category`);
    dispatch({
      type: GET_CATEGORIES,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: ERROR_CATEGORIES,
      payload: err
    });
  }
}

// categorías con más servicios disponibles (luego alfabético) para el home
export const getTopCategories = async (limit = 7) => {
  try {
    const res = await backendAxios.get(`/api/category/destacadas?limit=${limit}`);
    return res.data;
  } catch (err) {
    console.error("Error en getTopCategories", err);
    return [];
  }
}

// obtener las subcategorias por el id de categorias (2025)
export const getSubcategories = async id => {
  try {
    const res = await backendAxios.get(`/api/category/${id}/subcategory`);
    return res.data;
  } catch (err) {
    console.error("Error en getSubcategories", err);
  }
}

// get category by ID
export const getCategory = id => async dispatch => {
  try {
    const res = await axios.get(`${URL}/api/category/${id}`);
    dispatch({
      type: GET_CATEGORY,
      payload: res.data
    })
  } catch (err) {
    dispatch({
      type: ERROR_CATEGORIES,
      payload: err
    });
  }
}

// get subcategory by ID
export const getSubcategory = id => async dispatch => {
  try {
    const res = await axios.get(`${URL}/api/category/subcategory/${id}`);
    dispatch({
      type: GET_SUBCATEGORY,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: ERROR_CATEGORIES,
      payload: err
    });
  }
}

// get all categories para el directorio
export const getCategoriesByName = () => async dispatch => {
  try {
    const res = await axios.get(`${URL}/api/category/allbyname`);
    dispatch({
      type: GET_CATEGORIES,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: ERROR_CATEGORIES,
      payload: err
    });
  }
}